<!--Instructions-->
<div>
	<h4 style="text-align: center">Instructions:</h4>
	<div class="InstructionList">
		<label>1. Press Print to open a print-friendly image of the visitor's pass</label>
		<label>2. Press CTRL+P on the pass image page to print it</label>
		<label>3. Make sure you select the label printer (Ex. Dymo Wireless)</label>
		<label>4. Set <span class="BoldText">Layout</span> to <span class="BoldText">Landscape</span></label>
		<label>5. Press <span class="BoldText">More Settings</span></label>
		<label>6. Set <span class="BoldText">Paper Size</span> to <span class="BoldText">30256 Shipping</span></label>
		<label>7. Set <span class="BoldText">Scale (%)</span> to <span class="BoldText">Actual Size</span></label>
		<label>8. Set <span class="BoldText">Margins</span> to <span class="BoldText">None</span></label>
		<label>9. Press Print to print the Visitor Pass</label>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onPrint()">Print</button>
	<button class="btn btn-warning" (click)="onClose()">Close</button>
</div>
